import React from 'react';
import { UsingReportSection, TabbedOverviewPage } from '../components/OverviewSections.comp';

const AboutReportPage = () => (
    <TabbedOverviewPage
        skipNoDataGate
        tabs={[
            {
                label: 'What This Report Tells You',
                content: <UsingReportSection/>,
            },
        ]}
    />
);

export default AboutReportPage;
